export function DownloadPDF(pdf: string, _fileName: string) {
  const linkSource = `data:application/octet-stream;base64,${pdf}`;
  const downloadLink = document.createElement("a");
  const fileName = _fileName ? _fileName + ".pdf" : "PEAK_Document.pdf";
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.target = '_blank';
  downloadLink.rel = 'noopener noreferrer';

  downloadLink.click();
}
